import React from 'react';

export default (
    <svg
        width="23px"
        height="21px"
        viewBox="0 0 23 21"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g
            id="Calendar"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <rect
                id="Rectangle"
                stroke="#EAC9EF"
                strokeWidth="1.5"
                x="2.75"
                y="2.75"
                width="17.5"
                height="16.5"
                rx="2"
            ></rect>
            <path
                d="M8.5,8 L8.5,19"
                id="Stroke-115"
                stroke="#EAC9EF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M8.5,1 L8.5,4"
                id="Stroke-115-Copy-3"
                stroke="#EAC9EF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M14.5,8 L14.5,19"
                id="Stroke-115-Copy"
                stroke="#EAC9EF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M14.5,1 L14.5,4"
                id="Stroke-115-Copy-4"
                stroke="#EAC9EF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M3.45,7.5 L20.2324639,7.5"
                id="Stroke-106-Copy-2"
                stroke="#EAC9EF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M3.45,15.5 L20.2324639,15.5"
                id="Stroke-106-Copy-3"
                stroke="#EAC9EF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M3.45,11.5 L20.2324639,11.5"
                id="Stroke-106"
                stroke="#EAC9EF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
        </g>
    </svg>
);
